import React from 'react';
import { MathJaxContext } from 'better-react-mathjax';

const MATHJAX_CONFIG = {
  loader: { load: ['input/tex', 'output/chtml'] },
  tex: {
    inlineMath: [
      ['\\(', '\\)'],
      ['$', '$'],
    ],
    displayMath: [
      ['\\[', '\\]'],
      ['$$', '$$'],
    ],
  },
};

export default function MethodLongExplanationSection({ LongExplanation }) {
  return (
    <MathJaxContext version={3} config={MATHJAX_CONFIG} hideUntilTypeset="first">
      <section className="mt-10 w-full border-t border-white/30 pt-8 md:mt-16 md:pt-26">
        <div className="mx-auto w-full max-w-[1400px] px-4 text-white">
          <div className="relative text-sm leading-relaxed text-white/80 md:text-base">
            <div className="space-y-3">
              <LongExplanation />
            </div>
            <div className="clear-both" />
          </div>
        </div>
      </section>
    </MathJaxContext>
  );
}
